export function toCarbonSortOrder(
  sortOrder: 'asc' | 'desc' | 'ascending' | 'descending' | undefined | false,
): 'ascending' | 'descending' | undefined {
  if (sortOrder === 'ascending' || sortOrder === 'asc') return 'ascending';
  if (sortOrder === 'descending' || sortOrder === 'desc') return 'descending';
  return undefined;
}
